import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Button, Select } from 'antd'
import {
  LogoutOutlined,
  CaretDownOutlined,
  MenuOutlined,
} from '@ant-design/icons'
import httpRequest from '../../services/http-request'
import { navigate, Link } from '@reach/router'
import { CSVLink } from 'react-csv'

import LoadingSpinner from '../common/loading-spinner'

const PLReportByMarket = (props) => {
  const [loading, setLoading] = useState(false)
  const [userName, setUserName] = useState('')
  const defaultCurrency = props.currency
  const [currency, setCurrency] = useState(defaultCurrency)

  useEffect(() => {
    const userRole = localStorage.getItem('role')
    const loggedUserName = localStorage.getItem('userName')

    if (!userRole || !loggedUserName) {
      props.navigate('/login')
    }

    setUserName(loggedUserName)
  }, [])

  /**
   * Data grid section
   */
  const [rows, setRows] = useState([])
  const signedValueSpan = (value) => {
    if (value < 0) {
      return (
        <span className="value-span value-span--value-negative">
          {parseFloat(value).toFixed(2)}
        </span>
      )
    } else {
      return (
        <span className="value-span value-span--value-positive">
          {parseFloat(value).toFixed(2)}
        </span>
      )
    }
  }
  const valueSpan = (value) => {
    return <span className="value-span">{parseFloat(value).toFixed(2)}</span>
  }

  const processRows = (rows) => {
    return rows
  }

  const fetchData = async (signal) => {
    try {
      setLoading(true)
      const response = await httpRequest(
        `/api/reports/order-list?type=settled&page=1&marketId=${props.marketId}&currency=${currency}`,
        'GET',
        undefined,
        signal
      )
      console.log(response)
      const processedRows = processRows(response.data.result.pageRows)
      setRows(processedRows)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    const abortController = new AbortController()
    fetchData(abortController.signal)
    // return () => {
    //   console.log('aborting')
    //   abortController.abort()
    // }
  }, [])

  const handleFilterApplyClick = () => {
    fetchData()
  }

  const handleLogoutClick = () => {
    localStorage.removeItem('role')
    localStorage.removeItem('token')
    navigate('/login')
  }

  const getType = (marketType, value) => {
    const typeMap = {
      ODDS: {
        1: 'Lay',
        0: 'Back',
      },
      LINE: {
        1: 'No',
        0: 'Yes',
      },
    }
    return typeMap[marketType][value]
  }

  const [firstMatchedSort, setFirstMatchedSort] = useState(null)
  const [lastMatchedSort, setLastMatchedSort] = useState(null)

  const sortByMatched = (type) => {
    const sortedRows = rows.sort((a, b) => b[type] - a[type])
    setRows(sortedRows)
  }

  const handleSortFirstMatchedClick = () => {
    setFirstMatchedSort('desc')
    sortByMatched('firstMatchedTime')
    setLastMatchedSort(null)
  }

  const handleSortLastMatchedClick = () => {
    setLastMatchedSort('desc')
    sortByMatched('lastMatchedTime')
    setFirstMatchedSort(null)
  }

  /**
   * Currency filter section
   */
  const currencies = [
    { id: 'HKD', name: 'HKD' },
    { id: 'INR', name: 'INR' },
    { id: 'PKR', name: 'PKR' },
    { id: 'USD', name: 'USD' },
    { id: 'GBP', name: 'GBP' },
  ]

  const handleCurrencyChange = (value) => {
    setCurrency(value)
  }

  const buildCSV = () => {
    if (!rows) return []

    const csvString = rows
      .map((row) => {
        return `${row.loginName},${moment(row.betPlacedDate).format(
          'DD/MM/YYYY hh:mm:ss'
        )},${moment(row.firstMatchedTime).format(
          'DD/MM/YYYY hh:mm:ss'
        )},${moment(row.lastMatchedTime).format('DD/MM/YYYY hh:mm:ss')},${
          row.betPlacedIp
        },${row.marketBettingType === 'LINE' ? row.line : row.selectionName},${
          row.apolloBetId
        },${row.inPlay},${row.oneClick},${getType(
          row.marketBettingType,
          row.side
        )},${row.price},${row.averagePrice},${row.sizeMatched},${row.outcome},${
          row.memberWin
        },${row.agentWin}`
      })
      .join('\n')
    return `Member,Placed,First Matched ,Last Matched ,IP,Selection,Bet ID,In Play,1-Click,Type,Requested Odds,Average Price,Stake,Status,Member Win/Loss,Agent Win/Loss
    ${csvString}`
  }

  return (
    <>
      <div className="page-container">
        <div className="header">
          <div className="header__title">
            <h2>P&L Report by Market</h2>
            <div className="header__filters">
              <span className="filter">
                <span className="filter-label">Currency:</span>
                <Select
                  defaultValue={defaultCurrency}
                  style={{ width: 180 }}
                  onChange={handleCurrencyChange}
                >
                  {currencies.map((cr) => (
                    <Select.Option value={cr.id} key={cr.id}>
                      {cr.name}
                    </Select.Option>
                  ))}
                </Select>
              </span>
              <span className="filter">
                <Button
                  type="primary"
                  onClick={handleFilterApplyClick}
                  loading={loading}
                >
                  Apply
                </Button>
              </span>
              <span className="filter">
                <Button type="primary" danger>
                  Clear
                </Button>
              </span>
            </div>

            <span>
              <CSVLink
                data={buildCSV()}
                filename={`pl-report-by-market-bets-${new Date().getTime()}.csv`}
              >
                <Button type="primary">Download CSV</Button>
              </CSVLink>
            </span>
            <span className="header-span--pull-right">
              <span className="user-name">{userName}</span>
              <Button onClick={handleLogoutClick} type="primary" size="small">
                Logout <LogoutOutlined />
              </Button>
            </span>
          </div>
          {rows && rows.length > 0 && (
            <div className="header__filters">
              <Link to="/pl-report-by-market">Markets</Link> &nbsp; &gt;
              {`  ${rows[0].competitionName} ${rows[0].eventName} - ${rows[0].marketName}`}
            </div>
          )}
        </div>

        {!loading && (
          <div className="data-grid">
            <table>
              <thead>
                <tr>
                  <th>Member</th>
                  <th>Placed</th>
                  <th>
                    First Matched{' '}
                    <Button
                      type="text"
                      size="small"
                      onClick={handleSortFirstMatchedClick}
                    >
                      {firstMatchedSort === null && (
                        <MenuOutlined style={{ color: '#fff' }} />
                      )}
                      {firstMatchedSort === 'desc' && (
                        <CaretDownOutlined style={{ color: '#fff' }} />
                      )}
                    </Button>
                  </th>
                  <th>
                    Last Matched{' '}
                    <Button
                      type="text"
                      size="small"
                      onClick={handleSortLastMatchedClick}
                    >
                      {lastMatchedSort === null && (
                        <MenuOutlined style={{ color: '#fff' }} />
                      )}
                      {lastMatchedSort === 'desc' && (
                        <CaretDownOutlined style={{ color: '#fff' }} />
                      )}
                    </Button>
                  </th>
                  <th>IP</th>
                  <th>Selection</th>
                  <th>Bet ID</th>
                  <th>In Play</th>
                  <th>1-Click</th>
                  <th>Type</th>
                  <th>
                    Requested
                    <br />
                    Odds
                  </th>
                  <th>Average Price</th>
                  <th>Stake</th>
                  <th>Status</th>
                  <th>
                    Member
                    <br />
                    Win/Loss
                  </th>
                  <th>
                    Agent
                    <br />
                    Win/Loss
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows &&
                  rows.map((row) => (
                    <>
                      <tr key={row.apolloBetId}>
                        <td className="row-data row-data--bold row-data--left">
                          {`${row.loginName}`}
                        </td>
                        <td className="row-data row-data--left ">
                          {moment(row.betPlacedDate).format(
                            'DD/MM/YYYY HH:mm:ss'
                          )}
                        </td>
                        <td className="row-data row-data--left ">
                          {moment(row.firstMatchedTime).format(
                            'DD/MM/YYYY hh:mm:ss'
                          )}
                        </td>
                        <td className="row-data row-data--left ">
                          {moment(row.lastMatchedTime).format(
                            'DD/MM/YYYY hh:mm:ss'
                          )}
                        </td>
                        <td className="row-data row-data--left ">
                          {row.betPlacedIp}
                        </td>
                        <td className="row-data row-data--left ">
                          {row.marketBettingType === 'LINE'
                            ? row.line
                            : row.selectionName}
                        </td>
                        <td className="row-data row-data--left ">
                          {row.apolloBetId}
                        </td>
                        <td className="row-data row-data--left ">
                          {row.inPlay}
                        </td>
                        <td className="row-data row-data--left ">
                          {row.oneClick}
                        </td>
                        <td className="row-data row-data--left ">
                          {getType(row.marketBettingType, row.side)}
                        </td>
                        <td className="row-data row-data--left ">
                          {row.price}
                        </td>
                        <td className="row-data row-data--left ">
                          {row.averagePrice}
                        </td>
                        <td className="row-data row-data--left ">
                          {row.sizeMatched}
                        </td>
                        <td
                          className="row-data row-data--left "
                          style={{
                            color:
                              row.outcome === 'LOST' ? '#f44336' : '#8bc34a',
                          }}
                        >
                          {row.outcome}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(row.memberWin)}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(row.agentWin)}
                        </td>
                      </tr>
                    </>
                  ))}
              </tbody>
            </table>
          </div>
        )}
        {loading && <LoadingSpinner />}
      </div>
    </>
  )
}

export default PLReportByMarket
